/* eslint-disable no-undef */
export default function () {
  const widgetName = 'activitiesWidget';
  const widgetOpts = activitiesWidgetOpts;

  function toRight() {
    const splashes = $(`#${widgetName} .card-widget-item`);
    // if splashes.length > 3, select all the splashes after the 3rd one and add class 'toRight'
    const valueX = 7;
    const valueY = -180;
    if (window.innerWidth > 1300) {
      splashes.each(function (index) {
        if (splashes.length >= 3 && index > 2) {
          $(this).css('top', `${valueY}px`);
          $(this).css('z-index', '2');
          if (splashes.length === 6) {
            $(this).css('left', `${valueX + 3}%`);
          }
        } else if (index <= 2 && splashes.length === 6) {
          $(this).css('left', `${valueX * -1}%`);
        }
      });
    }
  }

  function toTop() {
    const splashes = $(`#${widgetName} .card-widget-item`);
    const value = -130;
    const numberOfSplashes = splashes.length;
    const widgetHeight = numberOfSplashes * 0.69 * 350;
    splashes.each(function (index) {
      if (index !== 0 && window.innerWidth < 804) {
        $(this).css('top', `${value * index}px`);
        $(`#${widgetName}`).css('height', `${widgetHeight}px`);
      } else if (
        index > 1 &&
        window.innerWidth > 804 &&
        window.innerWidth < 1300
      ) {
        $(this).css('top', `${value * Math.floor(index / 2)}px`);
        if (numberOfSplashes % 2 === 0) {
          $(`#${widgetName}`).css('height', `${widgetHeight / 2 + 40}px`);
        } else {
          $(`#${widgetName}`).css('height', `${widgetHeight / 2 + 140}px`);
        }
      } else if (index > 1 && innerWidth > 1300) {
        $(`#${widgetName}`).css('height', `${widgetHeight / 3 + 40}px`);
      }
    });
  }

  function getColorByPosition(index) {
    let colors = ['green', 'violet', 'pink'];
    let colorIndex = index % 3;
    if (window.innerWidth > 1300) {
      colors = ['green', 'violet', 'pink', 'pink'];
      colorIndex = index % 4;
    }
    return colors[colorIndex];
  }

  function applyColorPattern() {
    const splashes = $(`#${widgetName} .card-widget-item`);
    splashes.each(function (index) {
      const colorClass = getColorByPosition(index);
      $(this).addClass(colorClass);
    });
  }

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function () {
      toTop();
      toRight();
      applyColorPattern();
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: false,
    imageIsBackground: true,
    link: ['image'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 6,
    moreButton: {
      visible: false,
      text: 'MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: true,
  });
}
